<template>
    <div class="detailpage">
        <div class="top">
            <img src="../img/logo.png" alt="">
            <div class="line"></div>
            <img src="../img/min_title.png" alt="">
        </div>
        <div class="center">
             <router-view></router-view>
        </div>
    </div>
</template>

<script>
export default { 
  name: 'detailpage',

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.detailpage {
    width: 100%;
    min-height: calc(100% - 90px);
    padding-bottom: 90px;
    background-image: url(../img/bg.png);
    
    background-size: cover;
    .top {
        height: 115px;
        width: 100%;
        padding: 15px 18.75%;
        box-sizing: border-box;
        .line {
            display: inline-block;
            width: 1px;
            height: 50px;
            background-color: rgba(255,255,255,0.5);
            margin: 0 45px;
            vertical-align: super;
        }
        img:first-child {
            width: 130px;
        }
        img:last-child {
            width: 350px;
        }
    }
    .center {
        height: calc(100% - 205px);
        width: 100%;
        background-color: #ebf4fd;
    }
}
</style>
